export default __webpack_public_path__ + "static/media/Health professional team-bro.ac5ea213.png";